import { Heading, Stack, Text } from "@chakra-ui/react";
import { Fragment } from "react";

const items = [
  {
    title: "10 let",
    subtitle: "na trhu",
  },
  {
    title: "100",
    subtitle: "členný tým",
  },
  {
    title: "2 mil+",
    subtitle: "zájemců o bydlení ročně",
  },
  {
    title: "7 000",
    subtitle: "inzerátů měsíčně",
  },
  {
    title: "3 500 +",
    subtitle: "bytů ve správě",
  },
  {
    title: "500",
    subtitle: "makléřů ve spolupráci",
  },
];

const InfoBanner = () => (
  <Stack
    m="80px auto 0"
    gap={{ base: "32px", lg: "80px" }}
    align="center"
    justify="center"
    direction={{ base: "column", md: "row" }}
    py={{ base: "40px", md: "80px" }}
    bgColor="ud-grey-100"
  >
    {items.map(({ subtitle, title }, index) => (
      <Fragment key={index}>
        <Heading
          textAlign="center"
          bgGradient="linear-gradient(86deg, #E74C3C 0%, #E98540 100%)"
          bgClip="text"
        >
          {title}
          <Text>{subtitle}</Text>
        </Heading>
      </Fragment>
    ))}
  </Stack>
);

export default InfoBanner;
